var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSkype(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 1000,
    width: 990.833313,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 8.392999649,
    y1: 1.105999947,
    x2: 11.125,
    y2: 18.35400009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.012,
    stopColor: "#00b7f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.339,
    stopColor: "#009de5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.755,
    stopColor: "#0082d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0078d4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 14.37899971,
    y1: 26.64500046,
    x2: 29.54599953,
    y2: 17.88899994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0078d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#007ad5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573,
    stopColor: "#0082d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.735,
    stopColor: "#0090df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#00a3e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00bcf2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 10.44999981,
    y1: 6.68900013,
    x2: 24.29100037,
    y2: 30.66200066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00b7f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007cc1"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-381.7262001,-337.1428572)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 18.51799965,9.729999542 a 8.758999825,8.729999542 0 0 1 -8.758999825,8.729999538 8.758999825,8.729999542 0 0 1 -8.758999825,-8.729999538 8.758999825,8.729999542 0 0 1 8.758999825,-8.729999542 8.758999825,8.729999542 0 0 1 8.758999825,8.729999542",
    transform: "matrix(33.33333333,0,0,33.33333333,348.3928668,303.8095239)",
    style: {
      fill: "url(#a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 30.72499943,22.2670002 a 8.762000084,8.732999802 0 0 1 -8.76200009,8.7329998 8.762000084,8.732999802 0 0 1 -8.76200008,-8.7329998 8.762000084,8.732999802 0 0 1 8.76200008,-8.7329998 8.762000084,8.732999802 0 0 1 8.76200009,8.7329998",
    transform: "matrix(33.33333333,0,0,33.33333333,348.3928668,303.8095239)",
    style: {
      fill: "url(#b)"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m 1.032,10.477 a 8.758,8.758 0 1 0 9.817,-9.41 15.915,15.915 0 0 0 -9.817,9.41 z",
    fillRule: "evenodd",
    opacity: 0.05,
    transform: "matrix(33.33333333,0,0,33.33333333,348.3928668,303.8095239)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m 30.702,21.64 a 8.761,8.761 0 1 0 -9.533,9.324 15.915,15.915 0 0 0 9.533,-9.325 z",
    fillRule: "evenodd",
    opacity: 0.05,
    transform: "matrix(33.33333333,0,0,33.33333333,348.3928668,303.8095239)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m 1.442,12.473 a 8.755,8.755 0 1 0 11.398,-10.917 14.893,14.893 0 0 0 -11.398,10.917 z",
    fillRule: "evenodd",
    opacity: 0.1,
    transform: "matrix(33.33333333,0,0,33.33333333,348.3928668,303.8095239)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m 30.304,19.588 a 8.758,8.758 0 1 0 -11.192,10.939 14.893,14.893 0 0 0 11.192,-10.939 z",
    fillRule: "evenodd",
    opacity: 0.1,
    transform: "matrix(33.33333333,0,0,33.33333333,348.3928668,303.8095239)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m 1.764,13.301 a 8.753,8.753 0 1 0 11.894,-11.39 14.387,14.387 0 0 0 -11.894,11.39 z",
    fillRule: "evenodd",
    opacity: 0.1,
    transform: "matrix(33.33333333,0,0,33.33333333,348.3928668,303.8095239)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m 29.981,18.743 a 8.756,8.756 0 1 0 -11.713,11.444 14.386,14.386 0 0 0 11.713,-11.444 z",
    fillRule: "evenodd",
    opacity: 0.1,
    transform: "matrix(33.33333333,0,0,33.33333333,348.3928668,303.8095239)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m 29.73700047,16.06500053 a 13.87300014,13.82699966 0 0 1 -13.87300015,13.82699967 13.87300014,13.82699966 0 0 1 -13.873000145,-13.82699967 13.87300014,13.82699966 0 0 1 13.873000145,-13.82699966 13.87300014,13.82699966 0 0 1 13.87300015,13.82699966",
    transform: "matrix(33.33333333,0,0,33.33333333,348.3928668,303.8095239)",
    style: {
      fill: "url(#c)"
    }
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m 11.963,15.585 a 4.358,4.358 0 0 1 -1.367,-1.442 3.986,3.986 0 0 1 -0.468,-1.993 3.582,3.582 0 0 1 0.844,-2.412 5.08,5.08 0 0 1 2.2,-1.47 8.495,8.495 0 0 1 2.88,-0.485 11.184,11.184 0 0 1 1.916,0.147 6.918,6.918 0 0 1 1.329,0.343 2.576,2.576 0 0 1 1.04,0.664 1.344,1.344 0 0 1 0.321,0.893 1.294,1.294 0 0 1 -0.338,0.931 1.124,1.124 0 0 1 -0.849,0.354 1.529,1.529 0 0 1 -0.631,-0.142 11.434,11.434 0 0 0 -1.503,-0.55 5.455,5.455 0 0 0 -1.448,-0.18 3.305,3.305 0 0 0 -1.814,0.464 1.509,1.509 0 0 0 -0.724,1.355 1.363,1.363 0 0 0 0.376,0.953 3.426,3.426 0 0 0 1.013,0.725 q 0.637,0.316 1.9,0.838 a 1.97,1.97 0 0 1 0.272,0.109 13.497,13.497 0 0 1 2.352,1.209 4.742,4.742 0 0 1 1.448,1.486 3.92,3.92 0 0 1 0.523,2.064 4.151,4.151 0 0 1 -0.724,2.488 4.304,4.304 0 0 1 -2.025,1.503 8.537,8.537 0 0 1 -3.044,0.496 9.59,9.59 0 0 1 -4.149,-0.785 2.258,2.258 0 0 1 -0.854,-0.664 1.493,1.493 0 0 1 -0.278,-0.904 1.181,1.181 0 0 1 0.365,-0.92 1.345,1.345 0 0 1 0.941,-0.332 2.407,2.407 0 0 1 1.1,0.283 q 0.632,0.316 0.997,0.474 a 5.008,5.008 0 0 0 0.86,0.272 4.92,4.92 0 0 0 1.105,0.114 2.95,2.95 0 0 0 1.857,-0.495 1.635,1.635 0 0 0 0.626,-1.356 1.44,1.44 0 0 0 -0.392,-0.99 4.167,4.167 0 0 0 -1.154,-0.84 q -0.763,-0.402 -2.146,-0.98 a 13.291,13.291 0 0 1 -2.357,-1.225",
    fill: "#fff",
    fillRule: "evenodd",
    transform: "matrix(33.33333333,0,0,33.33333333,348.3928668,303.8095239)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkype);
export default __webpack_public_path__ + "static/media/skype.f0c4559a3f79e7c83244fd9f6a9135d8.svg";
export { ForwardRef as ReactComponent };